// STATUS
export const STATUS_CODES = {
	// success
	SUCCESS: 200,
	SUCCESS_POST: 201,
	SUCCESS_NO_CONTENT: 204,
	
	// error
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	VALIDATION_ERROR: 422,
	CONFLICT: 409,
	NOT_FOUND:404
}

export const STATUS_MSG = {
	AUTH_SERVICE_STATUS_SUCCESS_MSG: "ok",
	AUTH_SERVICE_HEALTH_CHECK_SUCCESS_MG: "green",
}

// SUCCESS AND ERROR
export const SUCCESS_MSG = {
	SUCCESS_TITLE: "Success!",
	SUCCESS_TEXT: "Your changes have been saved.",
}

export const ERROR_MSG = {
	INTERNAL_ERROR_TITLE: "Something went wrong!",
	INTERNAL_ERROR_MSG: "Please contact your administrator.",
	INTERNAL_CONNECTION_TIMEOUT: "Connection timeout. Please try again.",
	INTERNAL_ERROR: "Something went wrong! Please contact your administrator.",
	AUTH_SERVICE_404_MSG: "Invalid or Expired Link.",
	AUTH_SERVICE_403_MSG: "Invalid current password",
	TIMEOUT_EXCEEDED: "timeout of 20000ms exceeded",
	DROPZONE_UPLOAD_ERROR_TITLE: "Unable to Upload File",
	DROPZONE_UPLOAD_CANCELLED: "Upload canceled.",
	INACTIVE_USER: "Sorry. Your account is not active.",
}

// TOKEN
export const TOKEN = {
	EXPIRY: 86400000, // 24 hours
	EXPIRED: "Authorization token has expired!",
	INVALID: "Authorization token is invalid!",
	TELSTRA_EXPIRED: "Access Token expired",
}

// SOCIAL CLUB CONTENT TYPE
export const CONTENT_TYPE = {
	POST: "POST",
	COMMENT: "COMMENT",
}

// USER CLUB ACCESS
export const USER_CLUB_ACCESS = {
	CREATOR: "CC",
	MEMBER: "CM",
	ADMIN: "CA",
	PENDING: "PR",
}

// USER CLUB STATUS
export const USER_CLUB_STATUS = {
	ACTIVE: "A",
	INACTIVE: "I",
}

// USER CLUB CONTENT STATUS
export const CONTENT_STATUS = {
	APPROVED: "A",
	DISAPPROVED: "I",
	PENDING: "P",
}

// USER ROLES
export const USER_ROLES = {
	CUSTOMER: "CUST",
	ADMIN: "LADM",
	SUPER_ADMIN: "SADM",
	BREEDER: "BRDER",
	WALK: 'WALK',
	SITT: 'SITT',
	WASI: 'WASI',
}

// TRANSACTION STATUS
export const TRANSACTION_STATUS = {
	FOR_DELIVERY: "For delivery",
	OUT_FOR_DELIVERY: "Out for delivery",
	REQUEST_CANCELLATION: "For cancellation",
	CANCELLED: "Cancelled",
	REFUNDED: "Refunded",
	DELIVERED: "Delivered",
	FAILED: "FAILED",
}

// MEMBER CLUB GROUP STATUS
export const MEMBER_CLUB_GROUP_STATUS = {
	ACTIVE: "A",
	INACTIVE: "I",
	PENDING: "P",
}

// STATUS_TYPE
export const STATUS_TYPE = {
	A: "ACTIVE",
	P: "PENDING",
	DA: "DISAPPROVED",
	DEFAULT: "DISAPPROVED,ACTIVE,PENDING",
}

// STATUS
export const STATUS = {
	A: "APPROVED",
	P: "PENDING",
	C: "CANCEL",
	R: "REMOVED",
	DA: "DISAPPROVED",
	RQ: "REQUEST",
}

// DOG ORDER STATUS
export const DOG_ORDER_STATUS = {
	PENDING: "Dog order is pending",
	"For pickup": "Dog order is ready for pickup",
	"Picked up": "Dog order has been picked up",
	FAILED: "Dog order is failed",
	"For cancellation": "Requested for cancellation",
	Cancelled: "Approved dog order cancellation",
	Refunded: "Refunded",
	P: "Requested dog purchased is pending for approval",
	A: "Requested dog purchased is approved",
}

// DOG ORDER STATUS
export const PRODUCT_ORDER_STATUS = {
	PENDING: "Product order is pending",
	"For pickup": "Product order is ready for pickup",
	"Picked up": "Product order has been picked up",
	FAILED: "Product order is failed",
	"For cancellation": "Requested for cancellation",
	Cancelled: "Cancelled Order",
	P: "Requested product purchased is pending for approval",
	A: "Requested product purchased is approved",
}

// TRANSACTION STATUS
export const DOG_PURCHASE_STATUS = {
	PR: "PENDING REQUEST",
	A: "APPROVED",
	DA: "DISAPPROVED",
	DISAPPROVED_REFUND: 'DISAPPROVED REFUND',
	CR: "CANCELLED REQUEST",
	PP: "PENDING PAYMENT",
	FP: "FOR PICKUP",
	RR: "REQUEST FOR REFUND",
	CP: "CANCELLED PURCHASE",
	R: "REFUNDED",
	PU: "PICKED UP",
	F: "FAILED",
	D: "DELIVERED",
}

//PUPPY SELL STATUS
export const PUPPY_SELL_STATUS = {
	P: "PENDING",
	A: "AVAILABLE",
	S: "SOLD",
	D: "DECLINED",
	F: "FAILED",
	DISAPPROVED_REFUND: 'DISAPPROVED REFUND',
	REQUEST_REFUND: "REQUEST FOR REFUND",
	CANCELED: "CANCELLED",
	REFUNDED: "REFUNDED",
	PICKED_UP: "PICKED UP",
	PENDING_PAYMENT: "PENDING PAYMENT",
	HIDDEN: "HIDDEN",
}

export const PAYMENT_FREQUENCY_DISPLAY = {
    P1M: "Monthly",
    P3M: "Quarterly",
    P12M: "Yearly",
};

// USER STATUS
export const USER_STATUS = {
	PENDING: "P",
	WAITING: "W",
	ACTIVE: "A",
}

// BREEDER STATUS
export const BREEDER_STATUS = {
    P: "P",
    A: "A",
    D: "D",
    DECLINED: "DECLINED",
    DEACTIVATED: "DEACTIVATED",
    FOR_REACTIVATION: "FOR_REACTIVATION",
};

export const CANCELLATION_TYPE = {
	PRODUCT_REFUND: "PRODUCT_REFUND",
	SUBSCRIPTION_CANCELLATION: "SUBSCRIPTION_CANCELLATION",
}

export const WHELPING_DATE_STATUS = {
	ACTIVE: "ACTIVE",
	DELETED: "DELETED",
}

export const LITTER_STATUS = {
	ACTIVE: "ACTIVE",
	DELETED: "DELETED",
}

export const MATING_STATUS = {
	ACTIVE: "ACTIVE",
	DELETED: "DELETED",
	SUCCESSFUL: "SUCCESSFUL",
	UNSUCCESSFUL: "UNSUCCESSFUL",
}

export const DAM_SIRE_DOCUMENT_STATUS = {
	ACTIVE: "ACTIVE",
	DELETED: "DELETED",
	IN_PROGRESS: "IN_PROGRESS",
	UPLOADED: "UPLOADED",
	ERROR: "ERROR",
}